/**
 * @generated SignedSource<<27d3c009999195c43d1e26fe49ac85bb>>
 * @relayHash af6d4e6e482e8283add960be0340b924
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/513.0.0-2025-06-02T16:47:36.215Z/tradeVerifyFirmReminderQuery

import { ConcreteRequest } from 'relay-runtime';
export type tradeVerifyFirmReminderQuery$variables = {
  userId: string;
};
export type tradeVerifyFirmReminderQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly verifiedTradeStatus: string | null;
    } | null;
  };
};
export type tradeVerifyFirmReminderQuery = {
  response: tradeVerifyFirmReminderQuery$data;
  variables: tradeVerifyFirmReminderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedTradeStatus",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tradeVerifyFirmReminderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tradeVerifyFirmReminderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/513.0.0-2025-06-02T16:47:36.215Z/tradeVerifyFirmReminderQuery",
    "metadata": {},
    "name": "tradeVerifyFirmReminderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "82a3a6eb4a4103d9d58f8117686047cc";

export default node;
